<template>
  <div>
    <el-dialog  :visible.sync="messageDialogVisible">
      <div class="notification-container">
        <div class="header">
          <h2>消息通知</h2>
          <div>
            <!-- <el-button >全部消息</el-button>
            <el-button >未读消息</el-button> -->
            <el-button type="primary" @click="markAllAsRead">全部标记为已读</el-button>
          </div>
        </div>
        <div v-if="filteredNotifications.length > 0">
          <div v-for="notification in filteredNotifications" :key="notification.id"
            class="notification-item" :class="{ unread: !notification.readStatus==1 }">
            <div class="notification-content">
              <div class="notification-title">{{ notification.content }}</div>
              <div class="notification-time">{{ dateFormatYMDHMS(new Date(notification.createTime),'-') }}</div>
            </div>
            <div class="notification-actions">
              <el-button v-if="!notification.readStatus==1" type="text" @click.stop="markAsRead(notification)">标记已读</el-button>
              <el-button v-if="notification.messageType==3&&notification.oprationStatus==0" type="text" @click.stop="agreeInquiry(notification)">{{notification.oprationBtuName}}</el-button>
              <el-button type="text" @click.stop="deleteNotification(notification)" style="color: #f56c6c;">删除</el-button>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <div class="empty-icon">
            <i class="el-icon-bell"></i>
          </div>
          <p>暂无消息</p>
        </div>
        <Pagination :currentPage="page" :pageSizes="[10,20,30,40]" :parentPageSize="size" :totalNumber="totalNumber"
          @loadTable='getMessageList'></Pagination>
    </div>
    </el-dialog>
  </div>
</template>
<script>
import Api from '@/components/Api/index.js'
import Pagination from "@/components/Pagination.vue";
export default {
  components: {Pagination},
  data(){
    return{
      messageDialogVisible:false,
      filteredNotifications: [],
      page:1,
      size:10,
      totalNumber:0,
    }
  },
  methods:{
    openDialog(){
        this.messageDialogVisible=true
        this.getMessageList()
    },
    getMessageList(){
      new Api('oauth').getMessageList({page:this.page,size:this.size,q:{}}).then(res => {
        if (res.status == 200) {
          this.filteredNotifications = res.data.records
          this.totalNumber = res.data.total
        }
      })
    },
    // 标记单条消息为已读
    markAsRead(notification) {
      new Api('oauth').readMessage({messageId:notification.id}).then(res => {
        if (res.status == 200) {
          this.$set(notification,'readStatus',1)
          this.$message.success('消息已标记为已读');
        }
      })
    },
    // 标记所有消息为已读
    markAllAsRead() {
      new Api('oauth').readAllMessage().then(res => {
        if (res.status == 200) {
          this.filteredNotifications.forEach(notification => {
            this.$set(notification,'readStatus',1)
          });
          this.$message.success('所有消息已标记为已读');
        }
      }) 
    },
    agreeInquiry(item){
      new Api('oauth').agreeInquiry({inquiryId:item.oprationId}).then(res => {
        if (res.status == 200) {
          this.$set(item,'oprationStatus',1)
          this.$set(item,'readStatus',1)
          this.$message.success('接单成功，可在询单管理->项目询单中查看');
        }else{
          this.$message.error('系统异常')
        }
      })
    },
    // 删除消息
    deleteNotification(notification) {
      this.$confirm('确定要删除这条消息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        new Api('oauth').deleteMessage({messageId:notification.id}).then(res => {
        if (res.status == 200) {
          const index = this.filteredNotifications.findIndex(item => item.id === notification.id);
          if (index !== -1) {
            this.filteredNotifications.splice(index, 1);
          }
          this.$message.success('消息已删除');
        }
      })  
      }).catch(() => {
        // 用户取消删除
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.notification-container {
  max-width: 1200px;
  margin: 0 auto;
  background: white;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;
}
.notification-item {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
  transition: background-color 0.3s;
}
.notification-item:hover {
  background-color: #f5f7fa;
}
.notification-item.unread {
  background-color: #f0f9ff;
}
.notification-item.unread:hover {
  background-color: #e6f7ff;
}
.notification-content {
  flex: 1;
}
.notification-title {
  font-weight: bold;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.notification-time {
  color: #c0c4cc;
  font-size: 12px;
  margin-top: 5px;
}
.notification-actions {
  display: flex;
  align-items: center;
  margin-left: 15px;
}
.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
  color: #c0c4cc;
}
</style>
